<template>
    <v-card>
        <v-card-title class="primary white--text headline">
            Power Prediction
            <v-spacer></v-spacer>
        </v-card-title>
        <v-layout row wrap v-if="data">
            <v-flex xs12 v-for="equip in data">
                <vue-plotly disable-responsive :data="equip.data" :layout="equip.layout" :options="{}"/>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
    import VuePlotly from '@/components/VuePlotly'
    import {getResult} from '@/helper'

    export default {
        name: 'PowerForecast',
        components: {VuePlotly},
        computed: {
            facilityName() {
                return this.$store.state.pointsListStore.pointsList.facility_name;
            },

        },
        data() {
            return {
                loading: true,
                data: []
            }
        },
        methods: {},
        mounted() {
            let me = this;
            getResult({
                facility_name: me.facilityName,
                result_name: 'Power Prediction'
            }).then(function (res) {
                let result = res.result[0].content.result
                let data = []
                for (let equip in result) {
                    data.push({
                        "layout": {
                            title: equip,
                            xaxis: {title: "Actual Power"},
                            yaxis: {title: "Predicted Power"},
                        },
                        "data": [
                            {
                                x: result[equip].actual_comp_power,
                                y: result[equip].predicted_comp_power,
                                hovertext: result[equip].timestamp,
                                mode: "markers",
                            },

                        ]
                    })
                }
                me.data = data
                me.loading = false
            });
        }

    }
</script>

<style scoped>

</style>
